import {Component, OnInit, ViewChild, trigger, state, style, transition, animate} from '@angular/core';
import {NavController, NavParams, ModalController, Nav, App, Content, Platform, Events} from 'ionic-angular';

import {NewsService} from "../../providers/news-service";
import {NewsDetailPage} from "../news-detail/news-detail";
import {GetNewsService} from "../../providers/get-news-service";
import {StorageService} from "../../providers/storage";
import {KeywordsService} from "../../providers/keywords-service";
// import {CalendarPage} from "../calendar/calendar";

@Component({
  selector: 'page-feed',
  templateUrl: 'feed.html',
  animations: [
    trigger('pagefeed', [
      state('new', style({
          'background-color': 'white'
        })
      ),
      transition("void => *", [
        style({'background-color': '#ccffcc'}),
        animate(5000)
      ])
    ])
  ]
})
export class FeedPage implements OnInit {
  @ViewChild(Content) content: Content;
  news = [];
  loading = true;
  searchField = '';
  currentDate;
  today = new Date();
  showSearchField;
  hideSearch = false;  // gestisce la visualizzazione o meno del sistema di ricerca

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private _modal: ModalController,
    public newsService: NewsService,
    private getNewsService: GetNewsService,
    private app: App,
    private platform: Platform,
    private storageService: StorageService,
    private events: Events,
    private keywordsService: KeywordsService
  ) {
    if (this.platform.is('cordova')) {
      this.platform.ready().then(() => {
        this.getNewsService.registerDevice();
      })
    }
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad FeedPage');
  }

  ngOnInit() {
    // console.log('from menu');
    // console.log(this.navParams.get('fromMenu'));

    // l'app è già aperta
    this.storageService.set('warm', true);
    this.showSearchField = false;

    this.currentDate = (new Date());
    this.newsService.reset();
    /* this.events.subscribe('push_received',
      () => {
        if (typeof this.storageService.get('pushNewsId') !== 'undefined' && this.storageService.get('pushNewsId') !== '') {
          this.showNews(this.storageService.get('pushNewsId'));
        }
      }
    ); */

    // Inizializzo lo storage delle news
    if (typeof this.navParams.get('fromMenu') !== 'undefined') {
      this.newsService.selectArchive(this.navParams.get('fromMenu')).subscribe(
        () => {
          this.news = this.newsService.news;
          this.newsService.startNewsServer();
          if (typeof this.storageService.get('pushNewsId') !== 'undefined' && this.storageService.get('pushNewsId') !== '') {
            //this.showNews(this.storageService.get('pushNewsId'));
          }
        },
        () => {
        },
        () => {
          setTimeout(() => {
            this.loading = false;
          }, 2500);
        }
      );

    } else {
      // ricerca nelle sole news corrispondenti alle keywords
      // ottengo l'elenco delle keywords
      this.keywordsService.getKeywords().subscribe(
        (data) => {
          this.newsService.selectArchive("\\Globale").subscribe(
            () => {
              this.hideSearch = true;
              // nascondo il form di ricerca
              let tmpKey = [];
              for (let k of data) {
                tmpKey.push('(' + k.key + ')');
              }
              this.searchField = tmpKey.join(' OR ');
              this.loadFilters()
            })
        },
        err => console.log(err)
      )
    }

  }

  generateImage(news) {
    if (news.thumbnailUrl) {
      return news.thumbnailUrl;
    } else {
      let logo = this.newsService.getAgencyImage(news.agId);
      if (logo === null || logo === '') {
        return null;
      } else {
        return logo;
      }
    }
  };

  public doInfinite() {
    return this.newsService.getNextPage();
    //infiniteScroll.complete();
  }

  hasMorePage() {
    return this.newsService.hasMorePages();
  }

  showNews(id) {
    this.storageService.set('pushNewsId', '');
    let newsModal = this._modal.create(NewsDetailPage, {id: id});
    newsModal.onDidDismiss((data) => {

    });
    newsModal.present();
  }

  isSeen(id) {
    return this.newsService.isSeen(+id);
  }

  showSearchBar() {


  }

  showCalendar() {
    // let newsModal = this._modal.create(CalendarPage);
    // newsModal.onDidDismiss((data) => {
    //
    // });
    // newsModal.present();
  }

  onInput(event) {
    this.loadFilters();
  }

  onCancel(event) {
    this.onInput(event);
  }


  setDate(event) {
    this.currentDate = event;
    this.loadFilters();
  }


  loadFilters() {
    this.loading = true;
    if (this.searchField === '') {
      // console.log('search without data');
      this.newsService.reset();
      this.newsService.selectArchive(this.navParams.get('fromMenu'));
      this.news = this.newsService.news;
      this.newsService.changeDate(this.extractDate(this.currentDate)).subscribe(
        () => {
          this.newsService.startNewsServer();
        },
        () => {
        },
        () => {
          setTimeout(() => {
            this.loading = false;
          }, 2500);
        }
      );
    } else {
      // effettuo una ricerca corretta
      this.newsService.reset();
      this.news = this.newsService.news;
      this.newsService.changeDate(this.extractDate(this.currentDate)).subscribe(
        () => {
          this.newsService.search(this.searchField, this.extractDate(this.currentDate)).subscribe(
            () => {
              this.newsService.startNewsServer();
              ;

            });  // this.newsService.startNewsServer();
        },
        () => {
        },
        () => {
          setTimeout(() => {
            this.loading = false;
          }, 2500);
        }
      );

    }

  }

  extractDate(data: Date) {
    return ('0' + (data.getDate())).slice(-2) + '' + ('0' + (data.getMonth() + 1)).slice(-2) + '' + data.getFullYear()
  }

  nextDay() {
    this.currentDate = new Date(this.currentDate.getTime() + 1000 * 60 * 60 * 24);
    this.loadFilters();
  }

  previousDay() {
    this.currentDate = new Date(this.currentDate.getTime() - 1000 * 60 * 60 * 24);
    this.loadFilters();
  }

  scrollToTop() {
    this.content.scrollToTop();
    if (this.extractDate(this.currentDate) !== this.extractDate(this.today)) {
      // console.log('passato');
      this.currentDate = new Date();
      this.loadFilters();

    }
  }

  toggleSearch() {
    this.showSearchField = !this.showSearchField;
    // reset search if...
    if (this.showSearchField == false) {
      this.searchField = '';
      this.loadFilters();
    }
    this.content.resize();
  }

  onTop() {
    // console.log(this.content.scrollTop)
    return this.content.scrollTop == 0;
  }

  getItemClass() {
    let textSize = this.storageService.get('titleSize');
    if (textSize === "Little")
      return 'title-little';
    else if (textSize === "Normal")
      return 'title-normal';
    else if (textSize === "Large")
      return 'title-large';
    return 'title-normal';
  }
}



// WEBPACK FOOTER //
// ./src/pages/feed/feed.ts